// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "3.13.7/" + {"148":"locales","604":"avatar-3d","938":"stage-2"}[chunkId] + ".js";
};